import { Vehicle } from "./Vehicle";
import { VehicleType } from '../models/VehicleType';
import { VehicleOptions } from "./vehicleOptions";

export class Van extends Vehicle {
    canTransportFreightFun(): boolean {
        return true;
    }
    canTransportPassangerFun(): boolean {
        return true;
    }
    getTypeAsString(): string {
        return "Van"
    }
    constructor(id: number, make: string, model: string, licensePlate: string, gasUsae: number, pricePerKM: number, odometer: number, options: VehicleOptions, inUse?: boolean) {
        super(id, make, model, licensePlate, gasUsae, pricePerKM, odometer, true, true, VehicleType.Van, options, inUse);
    }
}